<!-- 调用日志-->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        class="ant-advanced-search-form"
        layout="inline"
        :form="form"
        @submit="handleSearch"
      >
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="系统名称">
              <a-input
                placeholder="请输入系统名称"
                v-model="queryParam.systemName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="系统代码">
              <a-input
                placeholder="请输入系统代码"
                v-model="queryParam.systemCode"
              ></a-input>
            </a-form-item>
          </a-col>
          <template v-if="expand">
            <a-col :md="8" :sm="12">
              <a-form-item label="耗时" class="wasteTime">
                <a-input
                  v-model="queryParam.minElapsedTime"
                  style="width: 46%"
                  :max-length="10"
                  @keyup="(e) => validateValue(e, 'minElapsedTime')"
                />
                <span style="flex: 1; text-align: center"> ～ </span>
                <a-input
                  :max-length="10"
                  v-model="queryParam.maxElapsedTime"
                  style="width: 46%"
                  @keyup="(e) => validateValue(e, 'maxElapsedTime')"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="12">
              <a-form-item label="调用时间">
                <a-range-picker
                  :show-time="true"
                  @change="dateChange"
                  v-model="dateRange"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="8" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="handleReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="toggle" style="margin-left: 8px">
                {{ expand ? '收起' : '展开' }}
                <a-icon :type="expand ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        size="middle"
        bordered
        :columns="columns"
        :data-source="dataList"
        rowKey="id"
        :scroll="{ x: 1000 }"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
      >
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
const columns = [
  {
    align: 'center',
    title: '系统名称',
    dataIndex: 'systemName',
    width: 200,
  },
  {
    align: 'center',
    title: '系统代码',
    dataIndex: 'systemCode',
    width: 200,
  },
  {
    align: 'center',
    title: '接口名',
    dataIndex: 'interfaceName',
    width: 200,
  },
  {
    align: 'center',
    title: '调用时间',
    dataIndex: 'callTime',
    width: 200,
  },
  {
    align: 'center',
    title: '完成时间',
    dataIndex: 'finishTime',
    width: 200,
  },
  {
    align: 'center',
    title: '时长（毫秒）',
    dataIndex: 'elapsedTime',
    width: 200,
  },
  {
    align: 'center',
    title: 'ip',
    dataIndex: 'ip',
    width: 200,
  },
  {
    align: 'center',
    title: '入参',
    dataIndex: 'requestParams',
    width: 200,
    ellipsis: true,
  },
  {
    dataIndex: 'responseParams',
    align: 'center',
    title: '出参',
    width: 200,
    ellipsis: true,
  },
];
export default {
  data() {
    return {
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns,
      form: this.$form.createForm(this),
      expand: false,
      selectedRowKeys: [],
      selectedRows: [],
      dataList: [],
      loading: false,
      queryParam: {
        systemName: '',
        systemCode: '',
        interfaceName: '',
        maxElapsedTime: '',
        minElapsedTime: '',
        startTime: '',
        endTime: '',
      },
      url: {
        list: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/interface/log/page',
      },
      dateRange: null,
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      let params = {
        ...this.queryParam,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      };
      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        this.loading = false;
        if (res.success) {
          this.dataList =
            res.result && res.result.records ? res.result.records : [];
          this.ipagination.total = res.result ? res.result.total : 0;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSearch() {
      this.initData();
    },
    handleReset() {
      this.queryParam = {
        systemName: '',
        systemCode: '',
        interfaceName: '',
        maxElapsedTime: '',
        minElapsedTime: '',
        startTime: '',
        endTime: '',
      };
      this.dateRange = null;
      this.initData();
    },
    toggle() {
      this.expand = !this.expand;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initData();
    },
    dateChange(date, dateStr) {
      this.queryParam.startTime = dateStr[0];
      this.queryParam.endTime = dateStr[1];
      console.log(dateStr, date);
    },
    validateValue(e, flg) {
      let regex = /^\d+$|^\d*\.\d+$/g;
      if (!regex.test(e.target.value)) {
        this.queryParam[flg] = '';
      }
    },
  },
};
</script>

<style scoped lang="less">
.table-operator {
  margin-bottom: 10px;
}
.wasteTime {
  /deep/.ant-form-item-control .ant-form-item-children {
    width: 100%;
    display: flex;
  }
}
</style>
